import styles from "./Contactusform.module.scss";
import { useState } from "react";
// import sendDiningForm from "../../../lib/sendDiningForm";
// import useDiningForm from "../../../hooks/useDiningForm";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function WeddingPageForm({ formId, formClass }) {
    const [selectDate, setSelectDate] = useState(new Date());
    const [selectedOption, setSelectedOption] = useState('');
    const [form, setForm] = useState({ state: '', message: '' });

    const [weddingFormData, setWeddingFormData] = useState({
        fullname: '',
        email: '',
        phoneno: '',
        message: ''
    });

    const handleDataChange = (e) => {
        const { name, value } = e.target;
        setWeddingFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const datenmonth = new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
    });

    const handleDateChange = (date) => {
        setSelectDate(date);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setForm({ state: 'loading' });

        try {
            const dataToSend = {
                ...weddingFormData,
                date: selectDate,
                selectedOption: selectedOption,
            };

            const res = await fetch(`/api/send-wedding-form`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend),
            });

            if (!res.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await res.json();
            setForm({
                state: 'success',
                message: result.success || 'Thank you! Your message has been delivered.',
            });

            // Reset form data
            // setWeddingFormData({
            //     fullname: '',
            //     email: '',
            //     phoneno: '',
            //     message: '',
            // });
            // setSelectedOption('');

        } catch (error) {
            console.error('Error:', error);
            setForm({
                state: 'error',
                message: error.message || 'Something went wrong',
            });
        }
    };

    return (
        <>
            <section className={`${styles.form} common_padding `}>
                <div className="row justify-content-center">
                    <div >
                        <h3 className='text-center'>Book your Special Day</h3>
                    </div>

                    <div className="col-md-7 col-sm-12 contact_form">
                        <form className={`row ${formClass ? formClass : ''}`} onSubmit={handleSubmit} id={formId} >
                            <div className={`${styles.form_group} col-md-6 col-sm-12`}>
                                <input
                                    id="fullname"
                                    type="text"
                                    name="fullname"
                                    onChange={handleDataChange}
                                    value={weddingFormData.fullname}
                                    className="form-control"
                                    placeholder="Full Name"
                                    required
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-6 col-sm-12`}>
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    onChange={handleDataChange}
                                    value={weddingFormData.email}
                                    className="form-control"
                                    placeholder="Your Email"
                                    required
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-6`}>
                                <input
                                    id="phoneno"
                                    required
                                    name="phoneno"
                                    type="number"
                                    onChange={handleDataChange}
                                    value={weddingFormData.phoneno}
                                    className="form-control"
                                    placeholder="Phone Number"
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-6`}>
                                <select value={selectedOption} onChange={(e) => setSelectedOption(e.target.value)}>
                                    <option value="">No. Of Attendees</option>
                                    <option value="150-200">50-200</option>
                                    <option value='200-250'>200-500</option>
                                    <option value='250-300'>500+</option>
                                </select>
                            </div>
                            <div className={`${styles.form_group} col-md-12`}>
                                <DatePicker
                                    wrapperClassName="diningform-date-picker"
                                    minDate={new Date()}
                                    className={styles.form_control}
                                    selected={selectDate}
                                    onChange={handleDateChange}
                                    placeholderText={'Please select a date'}
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-12`}>
                                <textarea
                                    id="message"
                                    name="message"
                                    onChange={handleDataChange}
                                    value={weddingFormData.message}
                                    className="form-control"
                                    placeholder="Message"
                                    required
                                ></textarea>
                            </div>
                            <button style={{ width: 'auto' }} type="submit" className="common_btn">SEND REQUEST</button>
                            {form.state === 'loading' ? (
                                <div>Sending....</div>
                            ) : form.state === 'error' ? (
                                <div className="form_message error">{form.message}</div>
                            ) : (
                                form.state === 'success' && <div className="form_message success">{form.message}</div>
                            )}
                            {/* {formMessage.state === 'loading' ? (
                                <div>Sending....</div>
                            ) : formMessage.state === 'error' ? (
                                <div className="form_message error">Something went wrong! Try again later.</div>
                            ) : (
                                formMessage.state === 'success' && <div className="success">Thankyou! Your Message has been delivered.</div>
                            )} */}
                        </form>
                    </div>
                </div>
            </section>
        </>
    )
}
